import React, { useEffect } from "react";
import climateAndSustainableDesignImg from '../Images/climateAndSustainableDesign.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function ClimateSustainableDesign() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={climateAndSustainableDesignImg} alt="Climate and Sustainable Design" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">Climate and Sustainable Design</h1>
                </div>
            </div>
            <div className="p-4 sm:p-8 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <h1 className="text-2xl mb-4 tracking-wider">
                        Climate and Sustainable Design at Architetive Designs
                    </h1>
                    <p className="text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Sustainability is a wide-ranging subject with many definitions. Addressing crucial concerns about climate change, we believe our projects must also encompass the health and wellbeing of our communities. This has been a central theme of our work for more than five decades. We work closely with our clients to develop bespoke design solutions that are optimised for their operations and the planet.
                    </p>
                    <p className="text-lg tracking-wider text-gray-700 font-light">
                        We have specialist in-house teams for carbon impact assessments, environmental analysis, materials research, landscape and workplace design, and environmental and structural engineering. Together with the design teams, they develop sustainable frameworks and identify environmental targets for a healthier world. We follow our projects through design and construction and can monitor the building performance while in-use.
                    </p>
                </div>
                <div className="mb-8">
                    <h1 className="text-2xl font-semibold mb-4">Environmental Approach</h1>
                    <p className="mb-6 text-gray-800 text-lg font-light tracking-wider">
                        We assess the environmental performance of our projects and develop innovative, future-proof solutions to mitigate the impact of climate change. Learning lessons from the Covid-19 pandemic, our focus is on resilience, flexibility, health and wellbeing. Our design approach addresses sustainability holistically, from efficient use of natural resources, circular economy strategies and biophilia to thermal comfort and indoor air quality. We seek to leverage the power of design to enhance the lived experience for all.
                    </p>
                </div>
                <div className="flex flex-row space-x-3 mb-4 md:mb-0">
                    <Link to='/contact'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Contact</button>
                    </Link>
                    <Link to='/careers/vacancies'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Vacancies</button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default ClimateSustainableDesign;